module.exports = __webpack_public_path__ + "img/26ne.abab66f2.svg";